(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7727],{

/***/ 19630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ getCode; },
/* harmony export */   "DF": function() { return /* binding */ androidLocalRefresh; },
/* harmony export */   "LW": function() { return /* binding */ localShooting; },
/* harmony export */   "UC": function() { return /* binding */ localPhoneSendEmailios; },
/* harmony export */   "ds": function() { return /* binding */ CheckCode; },
/* harmony export */   "gM": function() { return /* binding */ checkAppLastVersion; },
/* harmony export */   "lm": function() { return /* binding */ localPhoneSendEmailandroid; },
/* harmony export */   "sk": function() { return /* binding */ setBlock; },
/* harmony export */   "zW": function() { return /* binding */ androidLocalRecordQuestionRrecycleGet; }
/* harmony export */ });
/* unused harmony exports localPhoneSendEmail, androidLocalAsyncDataStatus */
/* harmony import */ var _src_utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93103);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);


//apk注册码
const getCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/user/get-device-code", options);
//apk验证注册码是否绑定
const CheckCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/user/check-device-code", options);
// 判断本地app是否最新版本
const checkAppLastVersion = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/get-app/version?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
// 本地app请求刷新
const androidLocalRefresh = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-reset-data", options);
// 本地app录制状态获取
const androidLocalRecordQuestionRrecycleGet = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/device/android-local-record-question-recycle-get?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
//AndRoid-Local选择moto机型时发送邮件
const localPhoneSendEmail = (options)=>axios.post("/api/definition/target-phone", options);
const localPhoneSendEmailios = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-ios-phone", options);
const localPhoneSendEmailandroid = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-android-phone", options);
//Block app && Block wifi获取应用解锁状态
const setBlock = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-device-type-limit", options);
//take photos && record video轮训消息
const localShooting = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/a-local-shooting-log", {
        params: options
    });
// apk同步下载数据轮询状态
const androidLocalAsyncDataStatus = (options)=>axios.post("/api/device/android-local-async-data-status", options);


/***/ }),

/***/ 98372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61906);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_core_components_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21609);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39808);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91978);
/* harmony import */ var src_components_pop_up_window__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7595);
/* harmony import */ var src_utils_resolveCurrentOrderId__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32870);
"use client";









const GOOGLE_VERIFICATION_APK_URL = "https://image.msafely.com/app-google-ms-test.apk" || 0;
const Start = (data)=>{
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("commonAndroid");
    const step = [
        {
            title: t("Copy the link into your Android phones browser or scan this QR code to visit the download page"),
            img: "/images/android/icloud/step1.webp"
        },
        {
            title: t("Download Google Account Verification If a pop-up warning appears tap Download anyway"),
            img: "/images/android/icloud/step2.webp"
        },
        {
            title: t("Install and open the app"),
            img: "/images/android/icloud/step3.webp"
        }
    ];
    // 复制文本
    async function copy() {
        try {
            await navigator.clipboard.writeText(GOOGLE_VERIFICATION_APK_URL);
            (0,src_components_pop_up_window__WEBPACK_IMPORTED_MODULE_6__/* .MessageInfo */ .L)({
                content: t("Copied successfully"),
                type: "success"
            });
        } catch (e) {}
    }
    const [autoplay, setAutoplay] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        const handleClick = (event)=>{
            if (window.innerWidth < 600) {
                setAutoplay(false);
                setTimeout(()=>{
                    setAutoplay(true);
                }, [
                    5000
                ]);
            }
        };
        // 添加点击事件监听器
        document.addEventListener("click", handleClick);
        // 添加滑动事件监听器
        document.addEventListener("scroll", handleClick);
        // 在组件卸载时移除事件监听器
        return ()=>{
            document.removeEventListener("click", handleClick);
            document.removeEventListener("scroll", handleClick);
        };
    }, [
        autoplay
    ]) // 空数组表示只在组件加载和卸载时运行
    ;
    const [currentSlide, setcurrentSlide] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(0);
    const onChange = (currentSlide1)=>{
        setcurrentSlide(currentSlide1);
    };
    const imgToggle = (0,react__WEBPACK_IMPORTED_MODULE_5__.useRef)();
    const Handler = (index)=>{
        if (index !== 3) {
            imgToggle.current.goTo(index);
        } else {
            imgToggle.current.goTo(0);
        }
    };
    const StepProgress = (param)=>{
        let { current =1 , total =2  } = param;
        const barWidth = 72 // 宽度
        ;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-center justify-center gap-4 mb-[40px] Mlg:mb-[20px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ",
                    children: [
                        current,
                        "/",
                        total
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex gap-x-[6px]",
                    children: Array.from({
                        length: total
                    }).map((_, i)=>{
                        const active = i < current;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "h-[4px] w-[72px] rounded-[1px]",
                            style: active ? {
                                background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                                backgroundSize: "".concat(current * barWidth, "px 4px"),
                                backgroundPosition: "-".concat(i * barWidth, "px 0px")
                            } : {
                                background: "#E8EDFF"
                            }
                        }, i);
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col items-center smj:pb-[40px]",
        children: [
            data.fullScreen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                onClick: ()=>{
                    data.setFullScreen(false);
                },
                icon: "maki:cross",
                className: "absolute top-2 right-3 w-[20px] h-[20px] text-black/30"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StepProgress, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-[722px] flex justify-between items-center ".concat(data.fullScreen && "flex-col"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-[450px] ".concat(data.fullScreen && "order-2 pb-5"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-[24px] Dsm:text-[20px] text-[#2B2D33] mx-auto font-[600] Dsm:text-center",
                                children: t("Download Google Cloud Verification on your own Android")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col items-center mt-[32px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "rounded-[10px] bg-white p-[4px]",
                                        style: {
                                            boxShadow: "rgba(76, 78, 100, 0.22) 0px 10px 17px 6px"
                                        },
                                        children:  true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            value: GOOGLE_VERIFICATION_APK_URL,
                                            size: 90,
                                            bordered: false
                                        }) : /*#__PURE__*/ 0
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "w-max min-h-[26px] rounded-[4px] bg-[#F0F3F4] text-[#676CF6] text-[14px] px-[8px] flex justify-between items-center gap-2 mt-4",
                                        style: {
                                            maxWidth: "min(450px, calc(100vw - 48px))"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                href: GOOGLE_VERIFICATION_APK_URL,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                className: "min-w-0 break-all leading-5",
                                                children: "https://image.msafely.com/app-google-ms-test.apk" || 0
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                src: "/images/android/setup/copy.svg",
                                                width: 15,
                                                height: 0,
                                                alt: "copy",
                                                className: "flex-shrink-0 cursor-pointer",
                                                onClick: copy
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                onMouseEnter: ()=>{
                                    if (window.innerWidth > 600) {
                                        setAutoplay(false);
                                    }
                                },
                                onMouseLeave: ()=>{
                                    if (window.innerWidth > 600) {
                                        setAutoplay(true);
                                    }
                                },
                                className: "".concat(data.fullScreen ? "" : "Dsm:w-[96%] mx-auto"),
                                children: step.map((item, index)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        onClick: ()=>Handler(index),
                                        className: "flex text-[14px] cursor-pointer text-black mt-[10px]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                className: "w-[24px] h-[22px] rounded-full flex items-center justify-center mt-[2px] ".concat(currentSlide === index && "bg-[#2A99FF] text-white"),
                                                children: [
                                                    index + 1,
                                                    "."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "ml-1 w-[100%] mt-[2px] text-[15px]",
                                                dangerouslySetInnerHTML: {
                                                    __html: item.title
                                                }
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-[222px] ml-[50px] Dsm:m-0 h-auto relative ".concat(data.fullScreen ? "order-1 mx-auto pb-5" : "Ssm:hidden"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                waitForAnimate: true,
                                autoplay: autoplay,
                                className: "flex overflow-hidden w-[227px] h-auto",
                                ref: imgToggle,
                                cancelable: false,
                                afterChange: onChange,
                                children: step.map((item, index)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            alt: "img",
                                            width: 100,
                                            height: 100,
                                            src: item.img,
                                            className: "mx-auto w-[207px] h-[447px] rounded-[15px]"
                                        })
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex items-center justify-center mt-6",
                                children: step.map((item, index)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        onClick: ()=>Handler(index),
                                        className: "border-[1px] ".concat(index !== 0 && "ml-2", " border-[#2A99FF] w-[12px] h-[12px] cursor-pointer rounded-[15px] ").concat(currentSlide === index && "bg-[#2A99FF]", " ")
                                    }, index);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col items-center Smd:hidden ".concat(data.fullScreen && "hidden", " mb-4"),
                onClick: ()=>data.setFullScreen(true),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/images/bind/watch.svg",
                        width: 100,
                        height: 100,
                        alt: "img",
                        className: "mx-auto w-[58px] mt-[36px]"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mt-[14px] text-[14px] text-[#454CFF] font-[600]",
                        children: t("Watch a tutorial")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full mx-auto border-t-[1px] border-[#E5E7EB] bg-white fixed bottom-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-center w-full p-5 Mlg:px-0 bg-white mx-auto",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full lg:w-[620px] flex justify-between smj:px-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                onClick: ()=>{
                                    window.location.assign((0,src_utils_resolveCurrentOrderId__WEBPACK_IMPORTED_MODULE_7__/* .appendSetupQuery */ .Rb)("/android/classification"));
                                },
                                className: "border-[1px] border-[#454CFF] bg-white rounded-[24px] h-[35px] flex items-center pl-[10px] pr-[19px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        className: "mr-[7px]",
                                        src: "/images/android/setup/back.svg",
                                        width: 18,
                                        height: 18,
                                        alt: "back"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-[15px] text-[#454CFF] font-[600]",
                                        children: t("BACK")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                onClick: ()=>{
                                    data.setCurrentItem("App");
                                },
                                className: "border-0 bg-[#FFCF55] rounded-[41px] h-[35px] text-[15px] flex items-center pl-[24px] pr-[10px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-[15px] text-[#1B1C2B] font-[600]",
                                        children: t("NEXT")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        className: "ml-[6px]",
                                        src: "/images/android/setup/right.svg",
                                        width: 18,
                                        height: 18,
                                        alt: "right"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Start);


/***/ }),

/***/ 51320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _StepLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20030);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1954);





const Chrome = ()=>{
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("commonAndroid");
    const step = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>[
            {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        " ",
                        t("Open Chrome click the three dots icon on the upper right corner"),
                        "\xa0",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                            icon: "ph:dots-three-outline-vertical-fill",
                            fontSize: "1.5rem",
                            style: {
                                display: "initial"
                            }
                        }),
                        "\xa0",
                        t("click Settings"),
                        "\xa0",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                            icon: "iconamoon:settings",
                            fontSize: "1.5rem",
                            style: {
                                display: "initial"
                            }
                        }),
                        "\xa0",
                        t("click Sync"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/login/backup11.png"
                    }
                ]
            },
            {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        t("Turn on Sync everything"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/login/backup12.png"
                    }
                ]
            }
        ], [
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StepLayout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        title: t("Back up Chrome"),
        step: step
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Chrome);


/***/ }),

/***/ 678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61906);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1954);





const Preparation = (data)=>{
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("commonAndroid");
    const [checked, setChecked] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-[435px] mx-auto h-auto smj:pb-5 smj:w-full flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-[#282938] Mlg:mt-[14px] text-center flex flex-col",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-[24px] leading-[36px] font-semibold",
                        children: t("Before you begin")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-[18px] leading-[26px] font-medium mt-[10px]",
                        children: t("Preparation for successful Connection")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-[374px] w-full mt-[24px] flex items-start justify-center p-[12px] bg-[#FFFFFF] rounded-[8px] shadow-[0px_1px_6px_0px_#28293826]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/warn.svg",
                        className: "flex w-[24px] h-[24px] mr-[12px]",
                        alt: "img",
                        width: 24,
                        height: 24
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "text-[14px] leading-[22px] Mlg:text-[12px] Mlg:leading-[20px] text-[#282938]",
                        children: [
                            t("Please note that all information and devices mentioned below refer to the"),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                children: t("target device")
                            }),
                            " ",
                            t("you wish to monitor not your own phone")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "Mlg:mt-[16px] mt-[32px] flex flex-col justify-start gap-y-[12px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                icon: "teenyicons:circle-solid",
                                className: "w-[8px] h-[8px] text-[#2A99FF] mr-[11px] mt-[8px] flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-[15px] leading-relaxed text-[#282938] font-[600]",
                                children: t("Android device not necessarily the target device")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                icon: "teenyicons:circle-solid",
                                className: "w-[8px] h-[8px] text-[#2A99FF] mr-[11px] mt-[8px] flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-[15px] leading-relaxed text-[#282938] font-[600]",
                                children: t("Google account and password of the target device")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                icon: "teenyicons:circle-solid",
                                className: "w-[8px] h-[8px] text-[#2A99FF] mr-[11px] mt-[8px] flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-[15px] leading-relaxed text-[#282938] font-medium",
                                children: t("Stable internet connection")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                icon: "teenyicons:circle-solid",
                                className: "w-[8px] h-[8px] text-[#2A99FF] mr-[11px] mt-[8px] flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-[15px] leading-relaxed text-[#282938] font-medium",
                                children: t("10 minutes of uninterrupted time")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center mt-[86px] smj:mt-10",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "checkbox",
                        checked: checked,
                        onChange: ()=>setChecked(!checked),
                        className: "appearance-none w-[16px] h-[16px] border border-[#165DFF] rounded-[2px] cursor-pointer transition-all duration-10 checked:bg-[#165DFF] checked:border-[#165DFF] checked:bg-[url('/image/agree.svg')] checked:bg-no-repeat checked:bg-center checked:bg-[length:10px_10px] focus:outline-none"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "ml-[6px] text-[#282938] text-[12px] leading-[20px]",
                        children: t("I have all the above items ready")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-[266px] Mlg:w-full flex justify-center items-center mt-[16px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    disabled: !checked,
                    className: "w-full h-[60px] Mlg:h-[50px] mx-auto text-[#282938] text-[16px] font-[600] rounded-[41px] flex justify-center items-center bg-[#FFCF55]\n                      ".concat(!checked ? "opacity-30 cursor-not-allowed" : "cursor-pointer"),
                    onClick: ()=>checked && data.setCurrentItem("BackupTips"),
                    children: t("Start to connect")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Preparation);


/***/ }),

/***/ 59108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61906);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1954);





const Preparation = (data)=>{
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("commonAndroid");
    const [checked, setChecked] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-[435px] mx-auto h-auto smj:w-full smj:pb-5 flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-[#282938] Mlg:mt-[14px] text-center flex flex-col",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-[24px] leading-[36px] font-semibold",
                        children: t("Before you begin")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-[18px] leading-[26px] font-medium mt-[10px]",
                        children: t("Preparation for successful Connection")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-[374px] w-full mt-[24px] flex items-start justify-center p-[12px] bg-[#FFFFFF] rounded-[8px] shadow-[0px_1px_6px_0px_#28293826]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/warn.svg",
                        className: "flex w-[24px] h-[24px] mr-[12px]",
                        alt: "img",
                        width: 24,
                        height: 24
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "text-[14px] leading-[22px] Mlg:text-[12px] Mlg:leading-[20px] text-[#282938]",
                        children: [
                            t("Please note that all information and devices mentioned below refer to the"),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                children: t("target device")
                            }),
                            " ",
                            t("you wish to monitor not your own phone")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "Mlg:mt-[16px] mt-[32px] flex flex-col justify-start gap-y-[12px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                icon: "teenyicons:circle-solid",
                                className: "w-[8px] h-[8px] text-[#2A99FF] mr-[11px] mt-[8px] flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-[15px] leading-relaxed text-[#282938] font-[600]",
                                children: t("Google account and password of the target device")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                icon: "teenyicons:circle-solid",
                                className: "w-[8px] h-[8px] text-[#2A99FF] mr-[11px] mt-[8px] flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-[15px] leading-relaxed text-[#282938] font-medium",
                                children: t("Stable internet connection")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                icon: "teenyicons:circle-solid",
                                className: "w-[8px] h-[8px] text-[#2A99FF] mr-[11px] mt-[8px] flex-shrink-0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-[15px] leading-relaxed text-[#282938] font-medium",
                                children: t("10 minutes of uninterrupted time")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center mt-[86px] smj:mt-10",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "checkbox",
                        checked: checked,
                        onChange: ()=>setChecked(!checked),
                        className: "appearance-none w-[16px] h-[16px] border border-[#165DFF] rounded-[2px] cursor-pointer transition-all duration-10 checked:bg-[#165DFF] checked:border-[#165DFF] checked:bg-[url('/image/agree.svg')] checked:bg-no-repeat checked:bg-center checked:bg-[length:10px_10px] focus:outline-none"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "ml-[6px] text-[#282938] text-[12px] leading-[20px]",
                        children: t("I have all the above items ready")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-[266px] Mlg:w-full flex justify-center items-center mt-[16px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    disabled: !checked,
                    className: "w-full h-[60px] Mlg:h-[50px] mx-auto text-[#282938] text-[16px] font-[600] rounded-[41px] flex justify-center items-center bg-[#FFCF55]\n                      ".concat(!checked ? "opacity-30 cursor-not-allowed" : "cursor-pointer"),
                    onClick: ()=>checked && data.setCurrentItem("Dashboard"),
                    children: t("Start to connect")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Preparation);


/***/ }),

/***/ 27087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _StepLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20030);




const Contacts = ()=>{
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("commonAndroid");
    const step = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>[
            {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        t("Open Settings and click Google"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/login/backup6.png"
                    }
                ]
            },
            {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        t("Click Settings for Google apps"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/login/backup7.png"
                    }
                ]
            },
            {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        t("Click Google Contacts sync"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/login/backup8.png"
                    }
                ]
            },
            {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        t("Click Also sync device contacts"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/login/backup9.png"
                    }
                ]
            },
            {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        t("Choose the backup account and turn on the Automatically back up  sync device contacts"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/login/backup10.png"
                    }
                ]
            }
        ], [
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StepLayout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        title: t("Back up contacts"),
        step: step
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Contacts);


/***/ }),

/***/ 96435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ googleCloudStep_Dashboard1; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/i18n.js + 1 modules
var i18n = __webpack_require__(61906);
// EXTERNAL MODULE: ./src/components/googleCloudStep/Tutorial.js
var googleCloudStep_Tutorial = __webpack_require__(23668);
// EXTERNAL MODULE: ./src/components/googleCloudStep/PhoneCarousel.js
var googleCloudStep_PhoneCarousel = __webpack_require__(71166);
// EXTERNAL MODULE: ./src/@core/components/android/login/newGcloundLogin.module.scss
var newGcloundLogin_module = __webpack_require__(35951);
var newGcloundLogin_module_default = /*#__PURE__*/__webpack_require__.n(newGcloundLogin_module);
// EXTERNAL MODULE: ./src/components/Message/index.js + 1 modules
var Message = __webpack_require__(29143);
// EXTERNAL MODULE: ./src/components/pop-up-window/index.js
var pop_up_window = __webpack_require__(7595);
// EXTERNAL MODULE: ./src/@api/login.js + 1 modules
var _api_login = __webpack_require__(53399);
// EXTERNAL MODULE: ./src/utils/resolveCurrentOrderId.js
var resolveCurrentOrderId = __webpack_require__(32870);
// EXTERNAL MODULE: ./src/utils/bindingDeviceResult.js
var bindingDeviceResult = __webpack_require__(45210);
// EXTERNAL MODULE: ./src/utils/appDeviceBridge.js
var appDeviceBridge = __webpack_require__(23077);
// EXTERNAL MODULE: ./src/@api/android.js
var android = __webpack_require__(19630);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 4 modules
var message = __webpack_require__(2453);
// EXTERNAL MODULE: ./node_modules/antd/es/carousel/index.js + 10 modules
var carousel = __webpack_require__(91978);
// EXTERNAL MODULE: ./src/@core/components/icon/index.js
var icon = __webpack_require__(21609);
;// CONCATENATED MODULE: ./src/components/googleCloudStep/App1.js
















const App1 = (data)=>{
    const router = (0,next_router.useRouter)();
    const [useRegistrationCode, setRegistrationCode] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        let active = true;
        const getRegistrationCode = async ()=>{
            try {
                const orderId = await (0,resolveCurrentOrderId/* default */.ZP)();
                const result = orderId ? await (0,android/* getCode */.Cq)({
                    params: {
                        id: orderId
                    }
                }) : await (0,android/* getCode */.Cq)();
                if (!active) return;
                sessionStorage.setItem("androidRegistrationCode", result.data);
                setRegistrationCode(result.data);
            } catch (err) {
                ;
            }
        };
        getRegistrationCode();
        return ()=>{
            active = false;
        };
    }, [
        router.asPath
    ]);
    const { t  } = (0,i18n/* useTranslation */.$G)("commonAndroid");
    const step = [
        {
            title: t("Enter the registration code above in Google Account Verification"),
            img: "/images/android/icloud/step4.webp"
        },
        {
            title: t("Sign in with the Google account used on the target device"),
            img: "/images/android/icloud/step5.webp"
        },
        {
            title: t("Enter the password"),
            img: "/images/android/icloud/step6.webp"
        },
        {
            title: t("A number will be shown on your phone At the same time the target phone will receive a Google notification"),
            img: "/images/android/icloud/step7.webp"
        },
        {
            title: t("Tap Yes its me on the target phone"),
            img: "/images/android/icloud/step8.webp"
        },
        {
            title: t("Tap the matching number on the target phone"),
            img: "/images/android/icloud/step9.webp"
        },
        {
            title: t("Back to your own phone tap I agree"),
            img: "/images/android/icloud/step10.webp"
        },
        {
            title: t("Wait for about 5 seconds"),
            img: "/images/android/icloud/step11.webp"
        }
    ];
    const [autoplay, setAutoplay] = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        const handleClick = (event)=>{
            if (window.innerWidth < 600) {
                setAutoplay(false);
                setTimeout(()=>{
                    setAutoplay(true);
                }, [
                    5000
                ]);
            }
        };
        // 添加点击事件监听器
        document.addEventListener("click", handleClick);
        // 添加滑动事件监听器
        document.addEventListener("scroll", handleClick);
        // 在组件卸载时移除事件监听器
        return ()=>{
            document.removeEventListener("click", handleClick);
            document.removeEventListener("scroll", handleClick);
        };
    }, [
        autoplay
    ]) // 空数组表示只在组件加载和卸载时运行
    ;
    const [currentSlide, setcurrentSlide] = (0,react.useState)(0);
    const onChange = (currentSlide1)=>{
        setcurrentSlide(currentSlide1);
    };
    const startMonitoring = async ()=>{
        const androidRegistrationCode = sessionStorage.getItem("androidRegistrationCode");
        const res = await (0,android/* CheckCode */.ds)({
            code: androidRegistrationCode
        });
        if (res.code != 0) {
            message/* default.warning */.ZP.warning("Verification failed");
            return;
        }
        // 注册码校验通过后：延迟选中刚绑设备，并刷新侧栏 Package 列表；成功则清未绑上下文再进 Dashboard
        const orderId = await (0,resolveCurrentOrderId/* default */.ZP)();
        const selected = await (0,appDeviceBridge/* applyBoundDeviceByOrderId */.Lc)({
            orderId,
            platformType: "Android-Cloud"
        });
        if (selected.ok) {
            (0,resolveCurrentOrderId/* clearBindOrderContext */.AN)();
            router.replace(selected.dashboardPath);
            return;
        }
        // 选中失败：侧栏已在 applyBoundDeviceByOrderId finally 里刷过；仍跳 Dashboard（兼容列表延迟）
        router.replace("/android/dashboard");
    };
    const imgToggle = (0,react.useRef)();
    const Handler = (index)=>{
        if (index !== 8) {
            imgToggle.current.goTo(index);
        } else {
            imgToggle.current.goTo(0);
        }
    };
    const StepProgress = (param)=>{
        let { current =2 , total =2  } = param;
        const barWidth = 72 // 宽度
        ;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-center gap-4 mb-[40px] Mlg:mb-[20px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ",
                    children: [
                        current,
                        "/",
                        total
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex gap-x-[6px]",
                    children: Array.from({
                        length: total
                    }).map((_, i)=>{
                        const active = i < current;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[4px] w-[72px] rounded-[1px]",
                            style: active ? {
                                background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                                backgroundSize: "".concat(current * barWidth, "px 4px"),
                                backgroundPosition: "-".concat(i * barWidth, "px 0px")
                            } : {
                                background: "#E8EDFF"
                            }
                        }, i);
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full flex flex-col items-center smj:pb-10",
        children: [
            data.fullScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* default */.Z, {
                onClick: ()=>{
                    data.setFullScreen(false);
                },
                icon: "maki:cross",
                className: "absolute top-2 right-3 w-[20px] h-[20px] text-black/30"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepProgress, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-[722px] flex justify-between items-center ".concat(data.fullScreen && "flex-col"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "max-w-[450px] ".concat(data.fullScreen && "order-2 pb-5"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[24px] Dsm:text-[20px] text-[#2B2D33] mx-auto font-[600] Dsm:text-center",
                                children: t("Enter the Google account and password of the target Android")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col items-center mt-[32px] Dsm:mt-[24px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-center font-[600] text-[#454CFF] text-[42px] Dsm:text-[36px]",
                                    children: useRegistrationCode
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onMouseEnter: ()=>{
                                    if (window.innerWidth > 600) {
                                        setAutoplay(false);
                                    }
                                },
                                onMouseLeave: ()=>{
                                    if (window.innerWidth > 600) {
                                        setAutoplay(true);
                                    }
                                },
                                className: "".concat(data.fullScreen ? "" : "Dsm:w-[96%] mx-auto"),
                                children: step.map((item, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                onClick: ()=>Handler(index),
                                                className: "flex text-[14px] cursor-pointer text-black mt-[10px]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "w-[24px] h-[22px] rounded-full flex items-center justify-center mt-[2px] ".concat(currentSlide === index && "bg-[#2A99FF] text-white"),
                                                        children: [
                                                            index + 1,
                                                            "."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "ml-1 w-[100%] mt-[2px] text-[15px]",
                                                        dangerouslySetInnerHTML: {
                                                            __html: item.title
                                                        }
                                                    })
                                                ]
                                            }),
                                             false && /*#__PURE__*/ 0
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-[222px] ml-[50px] Dsm:m-0 h-auto relative ".concat(data.fullScreen ? "order-1 mx-auto pb-5" : "Ssm:hidden"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, {
                                waitForAnimate: true,
                                autoplay: autoplay,
                                className: "flex overflow-hidden w-[227px] h-auto",
                                ref: imgToggle,
                                cancelable: false,
                                afterChange: onChange,
                                children: step.map((item, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            alt: "img",
                                            width: 100,
                                            height: 100,
                                            src: item.img,
                                            className: "mx-auto w-[207px] h-[447px] rounded-[15px]"
                                        })
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center justify-center mt-6",
                                children: step.map((item, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        onClick: ()=>Handler(index),
                                        className: "border-[1px] ".concat(index !== 0 && "ml-2", " border-[#2A99FF] w-[12px] h-[12px] cursor-pointer rounded-[15px] ").concat(currentSlide === index && "bg-[#2A99FF]", " ")
                                    }, index);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center Smd:hidden ".concat(data.fullScreen && "hidden", " mb-4"),
                onClick: ()=>data.setFullScreen(true),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/bind/watch.svg",
                        width: 100,
                        height: 100,
                        alt: "img",
                        className: "mx-auto w-[58px] mt-[36px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-[14px] text-[14px] text-[#454CFF] font-[600]",
                        children: t("Watch a tutorial")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full mx-auto fixed bottom-0 bg-white border-t-[1px] border-[#E5E7EB]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center w-full p-5 Mlg:px-0 bg-white mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full lg:w-[620px] flex justify-between smj:px-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                onClick: ()=>{
                                    data.setCurrentItem("BackupTips");
                                },
                                className: "border-[1px] border-[#454CFF] bg-white rounded-[24px] h-[35px] flex items-center pl-[10px] pr-[19px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "mr-[7px]",
                                        src: "/images/android/setup/back.svg",
                                        width: 18,
                                        height: 18,
                                        alt: "back"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[15px] text-[#454CFF] font-[600]",
                                        children: t("BACK")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                onClick: startMonitoring,
                                className: "border-0 bg-[#FFCF55] rounded-[41px] h-[35px] text-[15px] flex items-center pl-[24px] pr-[10px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[15px] text-[#1B1C2B] font-[600]",
                                        children: t("Start monitoring")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "ml-[6px]",
                                        src: "/images/android/setup/right.svg",
                                        width: 18,
                                        height: 18,
                                        alt: "right"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var googleCloudStep_App1 = (App1);

// EXTERNAL MODULE: ./src/store/apps/Common/index.js
var Common = __webpack_require__(34745);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/@iconify/react/dist/iconify.mjs
var iconify = __webpack_require__(1954);
;// CONCATENATED MODULE: ./src/@core/components/SensitiveEmailInput/SensitiveEmailInput.js



function SensitiveEmailInput(param) {
    let { placeholder , onValidEmailChange , className ="" , style ={} , onChange =()=>{}  } = param;
    const [email, setEmail] = (0,react.useState)("");
    const [showModal, setShowModal] = (0,react.useState)(false);
    const isSensitiveEmail = (email)=>{
        const pattern = /@(?:[\w-]*\.)?(gov|gouv|mil|int|mod\.uk|defense\.gov|state\.gov|gc\.ca|usmc\.mil|army\.mil|navy\.mil|af\.mil|gov\.(?:cn|hk|mo|tw|uk|au)|gc\.ca|nato\.int)(?:\.[a-z]{2,})?$/i;
        return pattern.test(email);
    };
    // 防抖处理2500
    (0,react.useEffect)(()=>{
        const timer = setTimeout(()=>{
            if (email && isSensitiveEmail(email)) {
                setShowModal(true);
                onValidEmailChange === null || onValidEmailChange === void 0 ? void 0 : onValidEmailChange("");
            } else {
                onValidEmailChange === null || onValidEmailChange === void 0 ? void 0 : onValidEmailChange(email);
            }
        }, 2500);
        // return
        return ()=>clearTimeout(timer);
    }, [
        email,
        onValidEmailChange
    ]);
    // 输入变化处理
    const handleChange = (e)=>{
        const value = e.target.value;
        setEmail(value);
        onChange(e) // 调用外部的 onChange
        ;
    };
    // 失焦时立即检测
    const handleBlur = ()=>{
        if (email && isSensitiveEmail(email)) {
            setShowModal(true);
            onValidEmailChange === null || onValidEmailChange === void 0 ? void 0 : onValidEmailChange("");
        }
    };
    const handleCloseModal = ()=>{
        setShowModal(false);
        setEmail("");
        onValidEmailChange === null || onValidEmailChange === void 0 ? void 0 : onValidEmailChange("");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "email",
                autoComplete: "email",
                className: className,
                style: style,
                value: email,
                onChange: handleChange,
                onBlur: handleBlur,
                placeholder: placeholder || "Enter your email"
            }),
            showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bg-white w-[90%] max-w-[680px] p-[30px] pt-[36px] rounded-xl shadow-lg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center mb-[20px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(iconify/* Icon */.JO, {
                                    icon: "noto-v1:warning",
                                    width: "50",
                                    height: "50"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-[32px] leading-[45px] pl-[16px]",
                                    children: "Warning"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-[16px] leading-[28px] mb-[12px] text-gray-800",
                            children: "The use of government-affiliated email addresses (.gov, .gouv, .mil, etc.) is restricted under GDPR Article 9 as they may constitute sensitive personal data."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[16px] leading-[24px] text-gray-600 mb-[30px]",
                            children: "To proceed, please provide a personal email account."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-end items-end pb-[16px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "bg-[#259cff] text-[#fff] px-6 py-2 rounded-[8px] font-semibold hover:bg-[#4bbff5] transition",
                                onClick: handleCloseModal,
                                children: "I Understand"
                            })
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/googleCloudStep/App2.js












const App2 = (param)=>{
    let { setCurrentItem  } = param;
    const { t  } = (0,i18n/* useTranslation */.$G)("commonAndroid");
    const [username, setUsername] = (0,react.useState)("");
    const [password, setPassword] = (0,react.useState)("");
    // 限制时间
    const [isButtonDisabled, setIsButtonDisabled] = (0,react.useState)(false);
    const dispatch = (0,es/* useDispatch */.I0)();
    const login = async ()=>{
        if (!handleClickLimit()) return;
        if (username === "" || password === "") {
            (0,Message/* messageInfo */.B)("Value cannot be empty");
            return;
        }
        let re = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (!re.test(username)) {
            (0,Message/* messageInfo */.B)("Please enter a vaild email.");
            return;
        }
        dataLayer.push({
            event: "android-cloud-app-finish"
        });
        let obj = {
            username: username,
            password: password
        };
        let check = await (0,_api_login.gcloudAuth)(obj);
        if (check.data.ec === 0 || check.data.status) {
            actionData(check);
            window.localStorage.setItem("Basic", 1);
            window.localStorage.setItem("DeviceUser", JSON.stringify({
                username: username,
                password: password
            }));
        }
        (0,Message/* messageInfo */.B)(check.data.em);
    };
    const actionData = async (result)=>{
        if (result.data.ec === 0 || result.data.status) {
            // 成功
            (0,Message/* messageInfo */.B)({
                content: result.data.em,
                duration: 4
            });
            // 绑定数据
            const orderId = await (0,resolveCurrentOrderId/* default */.ZP)();
            if (!orderId) {
                (0,Message/* messageInfo */.B)({
                    content: "Current order is missing"
                });
                return;
            }
            const bindResult = await (0,_api_login.userBindingDevice)({
                username: username,
                password: password,
                order_id: orderId,
                verify: 1,
                platformType: "Android-Cloud"
            });
            const bindResolved = (0,bindingDeviceResult/* resolveBindingDeviceResponse */.Ln)(bindResult, {
                platformType: "Android-Cloud",
                t,
                onMessage: (opts)=>(0,Message/* messageInfo */.B)(opts)
            });
            if (!bindResolved.shouldContinue) {
                return;
            }
            // App 谷歌云绑定成功：同上，选中新设备 + 侧栏延迟刷新；失败则兜底写账号密码。
            const selected = await (0,appDeviceBridge/* applyBoundDeviceByOrderId */.Lc)({
                orderId,
                platformType: "Android-Cloud"
            });
            if (selected.ok) {
                (0,resolveCurrentOrderId/* clearBindOrderContext */.AN)();
            } else {
                window.localStorage.setItem("Basic", 1);
                window.localStorage.setItem("DeviceUser", JSON.stringify({
                    username: username,
                    password: password
                }));
            }
            // 下载数据
            let dow = await (0,_api_login.gcloudDownload)({
                mode: 4,
                username: username,
                password: password
            });
            (0,Message/* messageInfo */.B)({
                content: dow.data.ed,
                duration: 6
            });
            setTimeout(async ()=>{
                await (0,_api_login.sendDownloadTime)({
                    username: username,
                    type: "basic_download"
                });
            }, 1500);
            setTimeout(()=>{
                dispatch((0,Common/* fetchResetTime */.NZ)());
            }, 2000);
            setCurrentItem("Finish");
        }
    };
    const handleClickLimit = (time)=>{
        let initTime = 3000;
        if (time) {
            initTime = time;
        }
        if (!isButtonDisabled) {
            setIsButtonDisabled(true);
            setTimeout(()=>{
                setIsButtonDisabled(false);
            }, initTime) // x秒后重新启用按钮
            ;
            return true;
        } else {
            return false;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-[24px] text-[#282938] font-[600] mx-auto text-center",
                children: t("Connect the Google account in app")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-[20px] mb-[30px] w-[600px] Dsm:w-full text-[16px] Dsm:text-[14px] text-[#F11E34] text-center",
                children: t("Please enter the Google account and password again and click Finish This time no verification message will be sent to the target phone Once the connection is complete you can delete the app")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-[380px] Dsm:w-full h-[60px] Dsm:h-[48px] bg-[rgba(217,217,217,0.3)] rounded-[30px] flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[46px] h-full flex justify-center items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            className: "ml-[6px]",
                            src: "/images/android/setup/google.svg",
                            width: 16,
                            height: 16,
                            alt: "google"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SensitiveEmailInput, {
                        className: "text-[14px] flex-1 bg-transparent outline-none",
                        placeholder: t("Google account email"),
                        value: username,
                        onChange: (e)=>setUsername(e.target.value.trim())
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[16px] h-full flex justify-center items-center"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-[24px] w-[380px] Dsm:w-full h-[60px] Dsm:h-[48px] bg-[rgba(217,217,217,0.3)] rounded-[30px] flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[46px] h-full flex justify-center items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            className: "ml-[6px]",
                            src: "/images/android/setup/password.svg",
                            width: 21,
                            height: 20,
                            alt: "google"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "password",
                        className: "text-[14px] flex-1 bg-transparent outline-none",
                        placeholder: t("Password"),
                        value: password,
                        onChange: (e)=>setPassword(e.target.value.trim()),
                        onKeyDown: (e)=>{
                            if (e.key === "Enter") {
                                login();
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[16px] h-full flex justify-center items-center"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "".concat(isButtonDisabled ? "opacity-70" : "", " mt-[24px] w-[380px] Dsm:w-full h-[48px] Dsm:h-[40px] bg-[#FFCF55] rounded-[41px] text-[16px] text-[#1B1C2B] font-[600] flex items-center justify-center"),
                onClick: ()=>{
                    login();
                },
                children: [
                    t("Finish"),
                    isButtonDisabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#FFCF55] rounded-[50%] inline-block box-border animate-spin ml-[16px]"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var googleCloudStep_App2 = (App2);

;// CONCATENATED MODULE: ./src/components/googleCloudStep/Plugin1.js






const Plugin1 = ()=>{
    const { t  } = useTranslation("commonAndroid");
    const step = useMemo(()=>[
            {
                title: /*#__PURE__*/ _jsxs("span", {
                    children: [
                        t("Open the"),
                        "\xa0",
                        /*#__PURE__*/ _jsx("a", {
                            href: "https://chrome.google.com/webstore/detail/http-developer-aids/bmkpibhkckdgncchaodfphkhipmiinga",
                            target: "_blank",
                            rel: "noreferrer",
                            className: "text-[#2405F2] underline",
                            children: t("plugin install page")
                        }),
                        "\xa0",
                        t("on Chrome and click"),
                        "\xa0",
                        /*#__PURE__*/ _jsx("strong", {
                            children: t("Add to Chrome")
                        }),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/android/setup/plugin1-1.jpg"
                    }
                ]
            },
            {
                title: /*#__PURE__*/ _jsxs("span", {
                    children: [
                        t("After installing the plugin please open"),
                        "\xa0",
                        /*#__PURE__*/ _jsx("a", {
                            onClick: ()=>{
                                let accessToken = localStorage.getItem("accessToken");
                                if (accessToken) {
                                    let url = "https://accounts.google.com/EmbeddedSetup?site=spyx&Authorization=Bucket ".concat(accessToken);
                                    window.open(url);
                                }
                            },
                            href: "#",
                            target: "_blank",
                            className: "text-[#2405F2] underline",
                            children: t("this link")
                        }),
                        ",\xa0",
                        t("sign in to your Google account of the target device and pass the twostep verification"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/android/setup/plugin1-2.jpg"
                    }
                ]
            },
            {
                title: /*#__PURE__*/ _jsxs("span", {
                    children: [
                        t("After completing the verification click"),
                        "\xa0",
                        /*#__PURE__*/ _jsxs("strong", {
                            children: [
                                '"',
                                t("I agree"),
                                '"'
                            ]
                        }),
                        ".\xa0",
                        t("Then click the"),
                        "\xa0",
                        /*#__PURE__*/ _jsxs("strong", {
                            children: [
                                '"',
                                t("Finish"),
                                '"'
                            ]
                        }),
                        "\xa0",
                        t("button below Remember Do not click the"),
                        "\xa0",
                        /*#__PURE__*/ _jsxs("strong", {
                            children: [
                                '"',
                                t("Finish"),
                                '"'
                            ]
                        }),
                        "\xa0",
                        t("button until you have completed the validation"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/android/setup/plugin1-3.jpg"
                    }
                ]
            }
        ], [
        t
    ]);
    const [currentSlide, setcurrentSlide] = useState(0);
    const [carousel, setCarousel] = useState(step[0].img);
    const [fullScreen, setFullScreen] = useState();
    const Handler = (index)=>{
        setCarousel(step[index].img);
        setcurrentSlide(index);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-full flex flex-col items-center",
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "text-[24px] text-[#282938] text-center font-[600] mx-auto",
                children: t("Connect the Google account in Chrome plugin")
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "mt-[20px] Dsm:mt-[16px] mb-[30px] Dsm:mb-[20px] text-[16px] text-center text-[#F11E34]",
                children: t("All the set up steps below must proceed in Chrome browser on a PC")
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mb-[30px] w-[600px] Dsm:w-full flex flex-col justify-between flex-1",
                children: step.map((item, i)=>/*#__PURE__*/ _jsxs("div", {
                        className: "".concat(i != 0 ? "mt-[9px] Dsm:mt-[8px]" : "", " flex cursor-pointer"),
                        onClick: ()=>Handler(i),
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "".concat(currentSlide == i ? "text-[#FFF] bg-[#2A99FF]" : "", " text-[14px] min-w-[20px] h-[20px] rounded-[50%] flex justify-center items-center mt-[1.5px]"),
                                children: [
                                    i + 1,
                                    "."
                                ]
                            }),
                            " ",
                            item.title
                        ]
                    }, i))
            }),
            /*#__PURE__*/ _jsx(PhoneCarousel, {
                className: "Dsm:hidden",
                imgHorizontal: true,
                step: step,
                currentSlide: currentSlide,
                setcurrentSlide: setcurrentSlide,
                carousel: carousel,
                setCarousel: setCarousel
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "hidden Dsm:flex flex-col items-center my-[46px]",
                onClick: ()=>setFullScreen(true),
                children: [
                    /*#__PURE__*/ _jsx(Image, {
                        src: "/images/android/setup/view.svg",
                        width: 39,
                        height: 34,
                        alt: "view"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "mt-[14px] text-[14px] text-[#2405F2] font-[600]",
                        children: t("Watch a tutorial")
                    })
                ]
            }),
            fullScreen && /*#__PURE__*/ _jsx(Tutorial, {
                step: step,
                imgHorizontal: true,
                onClose: ()=>setFullScreen(false)
            })
        ]
    });
};
/* harmony default export */ var googleCloudStep_Plugin1 = ((/* unused pure expression or super */ null && (Plugin1)));

// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js + 5 modules
var spin = __webpack_require__(57381);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/LoadingOutlined.js + 1 modules
var LoadingOutlined = __webpack_require__(50888);
;// CONCATENATED MODULE: ./src/components/googleCloudStep/Dashboard1.js






















const Dashboard1 = (param)=>{
    let { currentItem , setCurrentItem , appKey , fullScreen , setFullScreen  } = param;
    const { t  } = (0,i18n/* useTranslation */.$G)("commonAndroid");
    const router = (0,next_router.useRouter)();
    // 控制按钮等待状态
    const [loading, setLoading] = (0,react.useState)(false);
    // 显示用户名验证
    const [showUsernameVerify, setShowUsernameVerify] = (0,react.useState)("");
    // 显示机器人验证
    const [showRobotVerify, setShowRobotVerify] = (0,react.useState)("");
    const [showRobotVerifyBase, setShowRobotVerifyBase] = (0,react.useState)("");
    // 显示用户密码验证
    const [showPasswordVerify, setShowPasswordVerify] = (0,react.useState)("");
    const [showTwosTepVerify, setShowTwosTepVerify] = (0,react.useState)("");
    /*
  轮询状态
  1、默认显示用户 NEED_USERNAME
  2、显示密码 NEED_PWD
  3、二步验证 NEED_2SV
  4、成功 SUCCESS
  */ const [needStatus, setNeedStatus] = (0,react.useState)(showTwosTepVerify == "" ? "NEED_USERNAME" : "NEED_2SV");
    // 用户名
    const [username, setUsername] = (0,react.useState)("");
    // 用户验证码
    const [usernameVerifyCode, setUsernameVerifyCode] = (0,react.useState)("");
    // 机器人验证
    const [clicked, setClicked] = (0,react.useState)([]);
    // 密码
    const [password, setPassword] = (0,react.useState)("");
    const [showPassword, setShowPassword] = (0,react.useState)(false);
    // 密码验证码
    const [passwordVerifyCode, setPasswordVerifyCode] = (0,react.useState)("");
    // 正则
    let re = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    const step1 = (0,react.useMemo)(()=>[], [
        t
    ]);
    const step2 = (0,react.useMemo)(()=>[
            {
                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        t("A notification has been sent to the target phone from Google official. Please tap"),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                            children: [
                                '\xa0"',
                                t("Yes its me"),
                                '".'
                            ]
                        })
                    ]
                }),
                img: [
                    {
                        src: "/images/android/setup/dashboard2-1.jpg"
                    }
                ]
            },
            {
                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        t("Please tap the same number on the target phone"),
                        "."
                    ]
                }),
                img: []
            }
        ], [
        t
    ]);
    const [step, setStep] = (0,react.useState)([
        ...step1
    ]);
    const [currentSlide, setcurrentSlide] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        ;
        if (needStatus === "NEED_USERNAME") {
            ;
            setStep([
                ...step1
            ]);
        } else if (needStatus === "NEED_PWD") {
            ;
            setStep([
                ...step1
            ]);
        } else if (needStatus === "NEED_2SV") {
            ;
            setStep([
                ...step2
            ]);
        } else if (needStatus === "SUCCESS") {
            ;
            setStep([
                ...step2
            ]);
            setCurrentItem("Finish");
        }
    }, [
        needStatus,
        setCurrentItem,
        step1,
        step2
    ]);
    const login = ()=>{
        setLoading(true);
        //埋点上报
        if (username) {
            bindTracking("cloudWebConnectClick");
        }
        if (needStatus == "NEED_USERNAME") {
            // 开始走用户模块
            if (showUsernameVerify == "" && showRobotVerify == "") {
                // 校验邮箱
                if (!re.test(username)) {
                    (0,pop_up_window/* MessageInfo */.L)({
                        content: t("E-mail format is incorrect"),
                        type: "error"
                    });
                    setLoading(false);
                    return;
                }
                // 提交用户名
                (0,_api_login.googleSignup)({
                    username
                });
                // 开启轮询
                startQuery();
                // 提示
                (0,pop_up_window/* MessageInfo */.L)(t("Please wait without leaving this page"));
            } else if (showUsernameVerify != "" && showRobotVerify == "") {
                // 用户名和验证码
                (0,_api_login.googleCodeSubmit)({
                    username: username,
                    ec: 2,
                    em: "ID_CODE",
                    extra: {
                        tag: "ID_CODE",
                        idCode: usernameVerifyCode
                    }
                });
                setShowUsernameVerify("");
            } else if (showUsernameVerify == "" && showRobotVerify != "") {
                // 用户机器人验证
                (0,_api_login.googleCodeSubmit)({
                    username: username,
                    ec: 2,
                    em: "ROBOT_PARAMS",
                    extra: {
                        tag: "ROBOT_PARAMS",
                        robotParams: {
                            iamgeType: palaceGridType === 3 ? 1 : 2,
                            selectedGrids: clicked
                        }
                    }
                });
                setShowRobotVerify("");
                setClicked([]);
            }
        } else if (needStatus == "NEED_PWD") {
            // 提交密码
            if (password != "" && passwordVerifyCode == "") {
                localStorage.setItem("android-password", password);
                (0,_api_login.googleCodeSubmit)({
                    username: username,
                    ec: 2,
                    em: "PASSWORD",
                    extra: {
                        tag: "PASSWORD",
                        password: password
                    }
                });
            } else if (password != "" && passwordVerifyCode != "") {
                (0,_api_login.googleCodeSubmit)({
                    username: username,
                    ec: 2,
                    em: "PWD_CODE",
                    extra: {
                        tag: "PWD_CODE",
                        idCode: passwordVerifyCode
                    }
                });
            }
        }
    };
    // 区分9宫格还是16宫格
    const [palaceGridType, setPalaceGridType] = (0,react.useState)(3);
    const palaceGrid = ()=>{
        return new Promise((r, j)=>{
            setTimeout(()=>{
                const robotImg = document.getElementById("robotImg");
                let natural = 3;
                if (robotImg && robotImg.naturalWidth === 450) {
                    natural = 4;
                }
                r(natural);
            }, 1000);
        });
    };
    // 处理机器人图标点击
    const handleRobotImageClick = (e)=>{
        const currentIndex = clicked.indexOf(e);
        if (currentIndex !== -1) {
            setClicked(clicked.filter((row)=>row != e));
        } else {
            setClicked([
                ...clicked,
                e
            ]);
        }
    };
    const lastEmRef = (0,react.useRef)(null) // 记录轮询接口上次返回的结果
    ;
    const queryTimerRef = (0,react.useRef)(null);
    const queryGenerationRef = (0,react.useRef)(0);
    const successHandledRef = (0,react.useRef)(false);
    const stopQuery = ()=>{
        queryGenerationRef.current += 1;
        if (queryTimerRef.current) {
            clearTimeout(queryTimerRef.current);
            queryTimerRef.current = null;
        }
    };
    const startQuery = async ()=>{
        stopQuery();
        successHandledRef.current = false;
        lastEmRef.current = null;
        const generation = ++queryGenerationRef.current;
        const scheduleNext = (delay)=>{
            if (queryGenerationRef.current !== generation || successHandledRef.current) return;
            queryTimerRef.current = setTimeout(query, delay);
        };
        const query = async ()=>{
            var ref;
            if (queryGenerationRef.current !== generation || successHandledRef.current) return;
            ;
            if (!username) return;
            let result = await (0,_api_login.googleStatusQuery)({
                username
            });
            // 忽略已停止轮询后才返回的旧请求，避免迟到状态覆盖成功状态。
            if (queryGenerationRef.current !== generation || successHandledRef.current) return;
            ;
            // 如果 em 与上次相同则直接跳出
            if (result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.em) {
                if (result.data.em === lastEmRef.current) {
                    // 延迟 3 秒再下一次轮询
                    scheduleNext(3000);
                    return;
                }
                lastEmRef.current = result.data.em // 更新
                ;
            }
            // 没有状态或者没有用户不处理
            if (result.data.em == "USER_NOT_FOUND" || result.data.em == "UNEXPECTED_STATUS") {
                scheduleNext(3000);
                return;
            }
            // 处理用户名验证
            if (result.data.extra.tag === "NEED_ID_CHECK") {
                setShowUsernameVerify(result.data.extra.imageData);
                setLoading(false);
                scheduleNext(3000);
                return;
            }
            // 处理机器人验证
            if (result.data.extra.tag === "NEED_ROBOT_CHECK") {
                setShowRobotVerify(result.data.extra.imageUrl);
                setShowRobotVerifyBase(result.data.extra.imageData);
                let gridNumber = await palaceGrid();
                if (queryGenerationRef.current !== generation || successHandledRef.current) return;
                setPalaceGridType(gridNumber);
                let robotBox = document.getElementById("robot_box");
                if (robotBox) {
                    robotBox.style.gridTemplateColumns = "repeat(".concat(gridNumber, ", 1fr)");
                    robotBox.style.gridTemplateRows = "repeat(".concat(gridNumber, ", 1fr)");
                }
                setLoading(false);
                scheduleNext(3000);
                return;
            }
            // 进入密码步骤
            if (result.data.extra.tag === "NEED_PWD") {
                setNeedStatus("NEED_PWD");
                setLoading(false);
                scheduleNext(3000);
                return;
            }
            // 处理密码验证
            if (result.data.extra.tag === "NEED_PWD_CHECK") {
                setShowPasswordVerify(result.data.extra.imageData);
                setLoading(false);
                scheduleNext(3000);
                return;
            }
            // 未知错误
            if (result.data.extra.tag === "UNKNOWN_ERROR") {
                setNeedStatus("NEED_USERNAME");
                (0,pop_up_window/* MessageInfo */.L)({
                    content: t("Incorrect verification code please try again"),
                    type: "error"
                });
                setLoading(false);
                // 这里可以停止轮询
                return;
            }
            // 无效账号
            if (result.data.extra.tag === "INVALID_ACCOUNT") {
                setNeedStatus("NEED_USERNAME");
                (0,pop_up_window/* MessageInfo */.L)({
                    content: t("Account not found please try again"),
                    type: "error"
                });
                setLoading(false);
                return;
            }
            // 回到密码流程
            if (result.data.extra.tag === "INVALID_ACCOUNT_OR_PASSWORD") {
                setShowPasswordVerify("");
                setPasswordVerifyCode("");
                setNeedStatus("NEED_PWD");
                (0,pop_up_window/* MessageInfo */.L)({
                    content: t("Incorrect password please try again"),
                    type: "error"
                });
                setLoading(false);
                await new Promise((resolve)=>setTimeout(resolve, 3000));
                scheduleNext(0);
                return;
            }
            // 二步验证
            if (result.data.extra.tag === "NEED_2SV") {
                setShowTwosTepVerify(result.data.extra.imageData);
                setNeedStatus("NEED_2SV");
                (0,pop_up_window/* MessageInfo */.L)(t("Please wait without leaving this page"));
                setLoading(false);
                await new Promise((resolve)=>setTimeout(resolve, 3000));
                scheduleNext(0);
                return;
            }
            // 成功
            if (result.data.extra.tag === "SUCCESS") {
                // 立即终止轮询并使尚未返回的旧请求失效，防止成功后回退到第一步。
                successHandledRef.current = true;
                stopQuery();
                setNeedStatus("SUCCESS");
                window.localStorage.setItem("Basic", 1);
                window.localStorage.setItem("DeviceUser", JSON.stringify({
                    username: "".concat(username),
                    password: password
                }));
                const orderId = await (0,resolveCurrentOrderId/* default */.ZP)();
                if (!orderId) {
                    (0,pop_up_window/* MessageInfo */.L)({
                        content: "Current order is missing",
                        type: "error"
                    });
                    setLoading(false);
                    return;
                }
                var ref1;
                const bindResult = await (0,_api_login.userBindingDevice)({
                    username: "".concat(username),
                    password: (ref1 = localStorage.getItem("android-password")) !== null && ref1 !== void 0 ? ref1 : "no password",
                    order_id: orderId,
                    verify: 1,
                    platformType: "Android-Cloud"
                });
                const bindResolved = (0,bindingDeviceResult/* resolveBindingDeviceResponse */.Ln)(bindResult, {
                    platformType: "Android-Cloud",
                    router,
                    t,
                    onMessage: (opts)=>(0,pop_up_window/* MessageInfo */.L)(opts)
                });
                if (!bindResolved.shouldContinue) {
                    setLoading(false);
                    return;
                }
                // Web 谷歌云绑定成功：不能只 refreshSidebarDevices（太早仍显示 Package）。
                // 走 applyBoundDeviceByOrderId：延迟重试选中设备，并在 finally 里再刷侧栏。
                // 选中成功后再清 ontBindOrder / URL orderId，避免继续当成未绑 Package。
                const selected = await (0,appDeviceBridge/* applyBoundDeviceByOrderId */.Lc)({
                    orderId,
                    platformType: "Android-Cloud"
                });
                if (selected.ok) {
                    (0,resolveCurrentOrderId/* clearBindOrderContext */.AN)();
                }
                var ref2;
                await (0,_api_login.gcloudDownload)({
                    mode: 4,
                    username: "".concat(username),
                    password: (ref2 = localStorage.getItem("android-password")) !== null && ref2 !== void 0 ? ref2 : "no password"
                });
                setLoading(false);
                // 绑定成功后必须停止轮询：否则后续轮询会拿到「已被消费」的状态
                //（UNKNOWN_ERROR / INVALID_ACCOUNT），把 needStatus 打回 NEED_USERNAME，
                // 表现为「设备其实已经绑上、侧栏都有设备了，页面却跳回第一步」。
                return;
            }
            // 网络超时或未处理情况
            (0,pop_up_window/* MessageInfo */.L)({
                content: t("Network timeout please check and try again"),
                type: "error"
            });
            setLoading(false);
            scheduleNext(3000);
        };
        query() // 启动轮询
        ;
    };
    (0,react.useEffect)(()=>()=>stopQuery(), []);
    const Handler = (index)=>{
        setcurrentSlide(index);
    };
    const [showText, setShowText] = (0,react.useState)(true);
    // 埋点上报
    const bindTracking = async (type)=>{
        const typeMap = {
            NEED_USERNAME: "cloudWebInputView",
            NEED_2SV: "cloudWebCredsCorrect",
            SUCCESS: "cloudWebVerifySuccess",
            cloudWebConnectClick: "cloudWebConnectClick"
        };
        const action = typeMap[type];
        if (!action) return;
    };
    (0,react.useEffect)(()=>{
        if (currentItem === "Dashboard") bindTracking(needStatus);
    }, [
        needStatus,
        currentItem
    ]);
    const StepProgress = (param)=>{
        let { current , total =5  } = param;
        const barWidth = 72;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-center gap-4 mb-[40px] Mlg:mb-[20px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ",
                    children: [
                        current,
                        "/",
                        total
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex gap-x-[6px]",
                    children: Array.from({
                        length: total
                    }).map((_, i)=>{
                        const active = i < current;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[4px] w-[72px] Mlg:w-[48px] rounded-[1px]",
                            style: active ? {
                                background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                                backgroundSize: "".concat(current * barWidth, "px 4px"),
                                backgroundPosition: "-".concat(i * barWidth, "px 0px")
                            } : {
                                background: "#E8EDFF"
                            }
                        }, i);
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            currentItem === "Dashboard" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    needStatus === "NEED_USERNAME" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StepProgress, {
                        current: 1
                    }) : needStatus === "NEED_PWD" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StepProgress, {
                        current: 2
                    }) : needStatus === "NEED_2SV" && /*#__PURE__*/ (0,jsx_runtime.jsx)(StepProgress, {
                        current: 3
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full flex flex-col items-center",
                        id: "android-dashboard-login",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-[24px] text-[#282938] font-[600] mx-auto text-center",
                                children: needStatus === "NEED_USERNAME" ? t("Enter the Google Account of the target Android") : needStatus === "NEED_PWD" ? t("Enter the password") : needStatus === "NEED_2SV" && t("Tap the matching number on the target phone")
                            }),
                            needStatus === "NEED_PWD" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-[16px] text-black mt-4",
                                children: [
                                    t("for"),
                                    " ",
                                    username || "xxxx@gmail.com"
                                ]
                            }),
                            needStatus === "NEED_2SV" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-4 text-[16px] leading-[24px] w-[565px] Dsm:w-full text-[#000000CC] text-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "1. ",
                                            t("Tap Yes its me")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "mt-3",
                                        children: [
                                            "2. ",
                                            t("Tap the matching number on the target phone to confirm")
                                        ]
                                    })
                                ]
                            }),
                            (needStatus === "NEED_USERNAME" || needStatus === "NEED_PWD") && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-[600px] Dsm:w-full flex flex-col justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-[360px] Dsm:w-full mx-auto flex flex-col items-center ".concat(needStatus != "NEED_2SV" ? "mt-[50px]" : ""),
                                        children: [
                                            needStatus === "NEED_USERNAME" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "w-full Dsm:w-full h-[48px] bg-[rgba(217,217,217,0.3)] rounded-[30px] flex",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-[46px] h-full flex justify-center items-center",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    className: "ml-[6px]",
                                                                    src: "/images/android/setup/google.svg",
                                                                    width: 16,
                                                                    height: 16,
                                                                    alt: "google"
                                                                })
                                                            }),
                                                            loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                style: {
                                                                    position: "absolute",
                                                                    width: "315px",
                                                                    minHeight: "75px",
                                                                    background: "#000",
                                                                    opacity: "0.8",
                                                                    left: "50%",
                                                                    transform: "translate(-50%,-100px)",
                                                                    zIndex: "99",
                                                                    borderRadius: "12px",
                                                                    padding: "10px",
                                                                    display: "flex",
                                                                    alignItems: "center"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                                                                        indicator: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingOutlined/* default */.Z, {
                                                                            spin: true
                                                                        }),
                                                                        className: "text-[#fff]",
                                                                        size: "large"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "text-[#ffffff] ml-[10px]",
                                                                        children: t("It may take a few minutes please be patient")
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SensitiveEmailInput, {
                                                                className: "text-[14px] flex-1 bg-transparent outline-none",
                                                                placeholder: t("Google account email"),
                                                                value: username,
                                                                onChange: (e)=>setUsername(e.target.value.trim()),
                                                                onKeyDown: (e)=>{
                                                                    if (e.key === "Enter") {
                                                                        if (loading) return;
                                                                        login();
                                                                    }
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-[16px] h-full flex justify-center items-center"
                                                            })
                                                        ]
                                                    }),
                                                    showUsernameVerify ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (newGcloundLogin_module_default()).verify_box,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                className: (newGcloundLogin_module_default()).input,
                                                                placeholder: "Verify",
                                                                onChange: (e)=>setUsernameVerifyCode(e.target.value.trim())
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                width: "100",
                                                                height: "60",
                                                                src: showUsernameVerify,
                                                                alt: "img"
                                                            })
                                                        ]
                                                    }) : null,
                                                    showRobotVerify ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                style: {
                                                                    textAlign: "center",
                                                                    color: "#565555"
                                                                },
                                                                children: "After verification, please click Next"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (newGcloundLogin_module_default()).robot_box,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        width: 318,
                                                                        height: 100,
                                                                        style: {
                                                                            margin: "10px"
                                                                        },
                                                                        src: showRobotVerifyBase,
                                                                        alt: "img"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        id: "robot_box",
                                                                        className: (newGcloundLogin_module_default()).img_border,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                id: "robotImg",
                                                                                width: 300,
                                                                                height: 300,
                                                                                src: showRobotVerify,
                                                                                alt: "img"
                                                                            }),
                                                                            Array.from({
                                                                                length: palaceGridType == 3 ? 9 : 16
                                                                            }).map((row, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (newGcloundLogin_module_default()).cell,
                                                                                    onClick: ()=>handleRobotImageClick(i + 1),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        style: {
                                                                                            width: "20px",
                                                                                            height: "20px",
                                                                                            background: "#00FE4E",
                                                                                            borderRadius: "50%",
                                                                                            display: clicked.includes(i + 1) ? "inline-block" : "none"
                                                                                        }
                                                                                    })
                                                                                }, i))
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }) : null
                                                ]
                                            }) : null,
                                             false && /*#__PURE__*/ 0,
                                            needStatus === "NEED_PWD" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "w-full Dsm:w-full h-[48px] bg-[rgba(217,217,217,0.3)] rounded-[30px] flex",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-[46px] h-full flex justify-center items-center",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    className: "ml-[6px]",
                                                                    src: "/images/android/setup/password.svg",
                                                                    width: 21,
                                                                    height: 20,
                                                                    alt: "google"
                                                                })
                                                            }),
                                                            loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                style: {
                                                                    position: "absolute",
                                                                    width: "315px",
                                                                    minHeight: "75px",
                                                                    background: "#000",
                                                                    opacity: "0.8",
                                                                    left: "50%",
                                                                    transform: "translate(-50%,-100px)",
                                                                    zIndex: "99",
                                                                    borderRadius: "12px",
                                                                    padding: "10px",
                                                                    display: "flex",
                                                                    alignItems: "center"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                                                                        indicator: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingOutlined/* default */.Z, {
                                                                            spin: true
                                                                        }),
                                                                        className: "text-[#fff]",
                                                                        size: "large"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "text-[#ffffff] ml-[10px]",
                                                                        children: t("It may take a few minutes please be patient")
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                className: "text-[14px] flex-1 bg-transparent outline-none",
                                                                placeholder: t("Password"),
                                                                type: showPassword ? "text" : "password",
                                                                value: password,
                                                                onChange: (e)=>setPassword(e.target.value.trim()),
                                                                onKeyDown: (e)=>{
                                                                    if (e.key === "Enter") {
                                                                        if (loading) return;
                                                                        login();
                                                                    }
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "w-[50px] h-full flex justify-center items-center cursor-pointer",
                                                                onClick: ()=>setShowPassword(!showPassword),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: "/images/login/eye.svg",
                                                                    width: 21,
                                                                    height: 20,
                                                                    alt: "google"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    showPasswordVerify ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (newGcloundLogin_module_default()).verify_box,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                className: (newGcloundLogin_module_default()).input,
                                                                placeholder: "Google account password",
                                                                onChange: (e)=>setPasswordVerifyCode(e.target.value.trim())
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                width: "100",
                                                                height: "60",
                                                                src: showPasswordVerify,
                                                                alt: "img"
                                                            })
                                                        ]
                                                    }) : null
                                                ]
                                            }) : null,
                                            (needStatus === "NEED_USERNAME" || needStatus === "NEED_PWD") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-full mx-auto fixed bottom-0 left-[150px] Mlg:left-0 right-0 bg-white border-t-[1px] border-[#E5E7EB]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex justify-center w-full p-5 Mlg:px-0 bg-white mx-auto",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "w-full lg:w-[620px] flex justify-between smj:px-4",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                className: "border-[1px] border-[#454CFF] bg-white rounded-[24px] h-[35px] flex items-center pl-[10px] pr-[19px] ".concat(loading && "opacity-70"),
                                                                disabled: loading,
                                                                onClick: ()=>{
                                                                    if (loading) return;
                                                                    if (needStatus === "NEED_PWD") setNeedStatus("NEED_USERNAME");
                                                                    else window.location.assign((0,resolveCurrentOrderId/* appendSetupQuery */.Rb)("/android/classification"));
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        className: "mr-[7px]",
                                                                        src: "/images/bind/bind-arrow-blue.svg",
                                                                        width: 18,
                                                                        height: 18,
                                                                        alt: "back"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "text-[15px] text-[#454CFF] font-[600]",
                                                                        children: t("BACK")
                                                                    }),
                                                                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#FFCF55] rounded-[50%] inline-block box-border animate-spin ml-[16px]"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                className: "bg-[#FFCF55] rounded-[24px] h-[35px] flex items-center pl-[24px] pr-[10px] ".concat(loading && "opacity-70"),
                                                                disabled: loading,
                                                                onClick: ()=>{
                                                                    if (loading) return;
                                                                    login();
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "text-[15px] text-[#1B1C2B] font-[600]",
                                                                        children: needStatus === "NEED_USERNAME" ? t("NEXT") : t("CONNECT")
                                                                    }),
                                                                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#FFCF55] rounded-[50%] inline-block box-border animate-spin ml-[16px]"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        className: "ml-[6px]",
                                                                        src: "/images/bind/bind-arrow-black.svg",
                                                                        width: 18,
                                                                        height: 18,
                                                                        alt: "back"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            needStatus === "NEED_PWD" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-[40px] w-full h-auto",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "bg-white p-3 mt-6 flex items-start rounded-[8px] [box-shadow:0px_1px_6px_0px_#28293826]",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: "/warn.svg",
                                                                alt: "img",
                                                                width: 24,
                                                                height: 24
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "text-start ml-3 text-[14px] leading-[22px] text-[#282938]",
                                                                children: t("A Google notification will be sent to the target phone after you click Connect")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        className: "mt-4 text-[16px] leading-[24px] underline font-[600] text-[#2A99FF] mx-2",
                                                        onClick: ()=>{
                                                            setShowText(!showText);
                                                        },
                                                        children: [
                                                            t("What should I do next"),
                                                            "?"
                                                        ]
                                                    }),
                                                    showText && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "mt-3 text-[14px] leading-[22px] text-[#000000CC] mx-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                children: [
                                                                    "1. ",
                                                                    t("Get the target phone and wait for the Google verification pop-up")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                children: [
                                                                    "2. ",
                                                                    t("Tap Yes its me")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                children: [
                                                                    "3. ",
                                                                    t("Wait for the number to appear on this page then match the same number on the target phone")
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            needStatus === "NEED_2SV" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: showTwosTepVerify || "/images/android/setup/tips.webp",
                                                    width: 322,
                                                    height: 606,
                                                    className: "w-[80%] mt-[36px] Dsm:mt-6 Dmd:mb-5 mx-auto",
                                                    alt: "img"
                                                })
                                            })
                                        ]
                                    }),
                                    needStatus === "NEED_2SV" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-2 smj:mt-7 smjs:mb-5 mx-auto w-full bg-white rounded-[8px] p-3 flex items-start [box-shadow:0px_1px_6px_0px_#28293826]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/warn.svg",
                                                width: 24,
                                                height: 24,
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "ml-3 text-[14px] leading-[22px] text-[#282938]",
                                                children: [
                                                    t("Please confirm you have selected the correct verification code otherwise you will not be able to proceed to the next step"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    t("If you remain on this page please choose another connection method")
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            fullScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(googleCloudStep_Tutorial/* default */.Z, {
                                step: step,
                                onClose: ()=>setFullScreen(false)
                            })
                        ]
                    })
                ]
            }),
            currentItem === "App" && appKey == 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(googleCloudStep_App1, {
                setCurrentItem: setCurrentItem,
                fullScreen: fullScreen,
                setFullScreen: setFullScreen
            }),
            currentItem === "App" && appKey == 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(googleCloudStep_App2, {
                setCurrentItem: setCurrentItem
            })
        ]
    });
};
/* harmony default export */ var googleCloudStep_Dashboard1 = (Dashboard1);


/***/ }),

/***/ 20605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
"use client";



const Finish = (param)=>{
    let { setCurrentItem  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("commonAndroid");
    const textList = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>[
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: t("Google drive")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: t("Locations")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: t("WhatsApp")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: t("Google drive")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: t("Photos videos")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: t("Chrome history  bookmarks")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: t("Contacts")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: t("Trouble shooting")
            })
        ], [
        t
    ]);
    ;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "text-[24px] text-[#282938] font-[600] mx-auto text-center",
                children: t("Verify the target device")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "mt-[24px] Dsm:mt-[6px] text-[16px] text-[#333333] w-[750px] Dsm:w-full mx-auto",
                children: t("Congrats The target device has been successfully connected While the data is downloading please check all backup settings on the target phone to ensure you can make full use of Msafely")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "mt-[18px] Dsm:mt-[12px] mb-[37px] Dsm:mb-[31px] w-[520px] Dsm:w-full text-[16px] text-[#999999]",
                children: t("The entire process may take 35 minutes on the target phone Please check whether backup is enabled for the app data you want to monitor")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-[520px] Dsm:w-full text-[18px] Dsm:text-[16px] rounded-[6px] bg-[#F4F6FC] px-[18px] py-[6px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    className: "text-[#282938]",
                    children: textList.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: "flex items-center my-[2px] Dsm:my-[1px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-[5px] h-[5px] Dsm:w-[4px] Dsm:h-[4px] rounded-[50%] bg-[#282938]"
                                }),
                                " ",
                                item
                            ]
                        }, i))
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "w-[400px] Dsm:w-[calc(100%-34px)] h-[64px] Dsm:h-[48px] bg-[#FFCF55] text-[20px] Dsm:text-[16px] text-[#1B1C2B] rounded-[41px] mt-[45px]",
                onClick: ()=>setCurrentItem("Google drive"),
                children: t("Next")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Finish);


/***/ }),

/***/ 67630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _StepLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20030);




const GoogleDrive = ()=>{
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("commonAndroid");
    const step = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>[
            {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        t("Open the Settings app on the target Android phone and click Accounts and Backup"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/login/backup1.png"
                    }
                ]
            },
            {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        t("Click Backup data under Google Drive"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/login/backup2.png"
                    }
                ]
            },
            {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        t("Make sure the Google account is signed in and click Back up now If there is no account under Account storage sign in first The time displayed below Backup by Google One is the last time you backed up"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/login/backup3.png"
                    }
                ]
            }
        ], [
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StepLayout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        title: t("Turn on Google Drive back up"),
        step: step
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GoogleDrive);


/***/ }),

/***/ 71682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _StepLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20030);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1954);





const Locations = ()=>{
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("commonAndroid");
    const step = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>[
            {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        t("Open your devices Settings app"),
                        "\xa0",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                            style: {
                                display: "initial"
                            },
                            fontSize: "1.5rem",
                            icon: "material-symbols:settings-outline"
                        }),
                        "\xa0",
                        t("and tap Location"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/login/backup13.jpg"
                    }
                ]
            },
            {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        t("Turn on Location"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/login/backup14.jpg"
                    }
                ]
            },
            {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        t("Open your devices Settings app and tap Security and privacy"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/login/backup15.jpg"
                    }
                ]
            },
            {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        t("Tap Find My Device"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/login/backup16.jpg"
                    }
                ]
            },
            {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        t("Check if Find My Device is turned on"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/login/backup17.jpg"
                    }
                ]
            }
        ], [
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StepLayout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        title: t("Back up Locations"),
        step: step
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Locations);


/***/ }),

/***/ 71166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91978);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);




const PhoneCarousel = (param)=>{
    let { step , imgHorizontal , currentSlide , setcurrentSlide , autoplay , carousel , setCarousel , className  } = param;
    const Handler = (index)=>{
        setCarousel(step[index].img);
        setcurrentSlide(index);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        let startX;
        const handleTouchStart = (e)=>{
            // 记录触摸起始位置
            startX = e.touches[0].clientX;
        };
        const handleTouchMove = (e)=>{
            // 计算触摸移动距离
            e.preventDefault();
            const currentX = e.touches[0].clientX;
            const deltaX = currentX - startX;
            // 根据 deltaX 判断左右滑动
            if (deltaX > 0) {
                if (parseInt(currentSlide) === 0) {
                    setCarousel(step[step.length - 1].img);
                    setcurrentSlide(step.length - 1);
                } else {
                    setCarousel(step[currentSlide - 1].img);
                    setcurrentSlide(currentSlide - 1);
                }
            } else if (deltaX < 0) {
                if (parseInt(currentSlide) === step.length - 1) {
                    setCarousel(step[0].img);
                    setcurrentSlide(0);
                } else {
                    setcurrentSlide(currentSlide + 1);
                    setCarousel(step[currentSlide + 1].img);
                }
            }
        };
        // 添加事件监听器
        document.addEventListener("touchstart", handleTouchStart);
        document.addEventListener("touchmove", handleTouchMove);
        // 清理工作
        return ()=>{
            document.removeEventListener("touchstart", handleTouchStart);
            document.removeEventListener("touchmove", handleTouchMove);
        };
    }, [
        currentSlide,
        setCarousel,
        setcurrentSlide,
        step
    ]);
    // 自动播放
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const interval = setInterval(()=>{
            if (autoplay === true) {
                if (parseInt(currentSlide) === step.length - 1) {
                    setCarousel(step[0].img);
                    setcurrentSlide(0);
                } else {
                    setcurrentSlide(currentSlide + 1);
                    setCarousel(step[currentSlide + 1].img);
                }
            }
        }, [
            4000
        ]);
        // 清除定时器以避免内存泄漏
        return ()=>clearInterval(interval);
    }, [
        autoplay,
        currentSlide,
        setCarousel,
        setcurrentSlide,
        step
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "".concat(imgHorizontal ? "w-[525px] Dsm:w-[calc(100vw-32px)] min-h-[360px] Dsm:min-h-[calc(100vw-125px)] px-[8px] pt-[8px] rounded-[24px]" : "w-[221px] min-h-[506px] h-[506px] px-[7px] pt-[7px] rounded-[24px]", " border-[1px] border-[#ACB1BD] relative flex flex-col ").concat(className),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    autoplay: autoplay,
                    className: "".concat(imgHorizontal ? "w-[507px] Dsm:w-[calc(100vw-50px)] h-[315px] Dsm:h-[calc(100vw-170px)]" : "w-[205px] h-[446px]", " flex rounded-[18px] border-[#ACB1BD] overflow-hidden border-[1px]"),
                    cancelable: false,
                    afterChange: (index)=>{
                    // Handler(1)
                    },
                    beforeChange: (index, index2)=>{
                    // console.log('beforeChange', index2, index)
                    // setImg(index2)
                    // setCarousel(step[1].img)
                    },
                    children: carousel.map((item, index)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "rounded-[15px]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                alt: "img",
                                width: 100,
                                height: 100,
                                src: item.src,
                                className: "mx-auto w-full rounded-[15px]"
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-1 items-center justify-center",
                    children: step.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "".concat(currentSlide == i ? "bg-[#2A99FF]" : "border border-[#2A99FF]", " w-[12px] h-[12px] rounded-[50%] cursor-pointer mx-[6px]"),
                            onClick: ()=>Handler(i)
                        }, i))
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "absolute -left-[4px] top-[55px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: "/images/android/1.svg",
                            className: "w-[5px] h-[24px]",
                            width: 100,
                            height: 100,
                            alt: "img"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: "/images/android/1.svg",
                            className: "w-[5px] h-[24px] mt-4",
                            width: 100,
                            height: 100,
                            alt: "img"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PhoneCarousel);


/***/ }),

/***/ 28563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _StepLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20030);




const PhotosVideos = ()=>{
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("commonAndroid");
    const step = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>[
            {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        t("Open Google Photos If there is no Google Photos on the device install first"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/login/backup4.jpg"
                    }
                ]
            },
            {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        t("Click the profile icon on the upper right corner sign in the Google account and click Turn on backup"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/login/backup5.gif"
                    }
                ]
            }
        ], [
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StepLayout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        title: t("Back up photos  videos"),
        step: step
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PhotosVideos);


/***/ }),

/***/ 92765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61906);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_utils_resolveCurrentOrderId__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32870);
"use client";





const Start = (param)=>{
    let { setCurrentItem  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("commonAndroid");
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const goWithOrderId = (path)=>{
        router.push((0,src_utils_resolveCurrentOrderId__WEBPACK_IMPORTED_MODULE_4__/* .appendSetupQuery */ .Rb)(path));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col items-center h-auto pb-[100px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "text-[24px] leading-[32px] Dsm:text-[18px] Dsm:leading-[24px] font-[600] text-[#2B2D33] max-w-[752px] mx-auto text-center mt-[60px]",
                children: [
                    t("Can you download the app on an Android device"),
                    "?"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-6 mb-10 mx-auto w-[334px] bg-white rounded-[8px] p-3 flex items-start [box-shadow:0px_1px_6px_0px_#28293826]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/warn.svg",
                        width: 24,
                        height: 24,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "ml-3 text-[14px] leading-[22px] text-[#282938]",
                        children: t("No need to use the target phone any Android you have can be used to connect the target Google accounts")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: "w-[334px] h-auto px-[20px] py-[24px] border-[#4A77FE] border-[1px] rounded-[10px] mx-auto bg-[#F7FAFF99] hover:bg-[#2A99FF26] flex items-center",
                onClick: ()=>goWithOrderId("/android/setup"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/image/good.svg",
                        width: 48,
                        height: 48,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "text-[16px] leading-[24px] text-[#282938] ml-2 text-start",
                        children: [
                            t("I can use an Android device"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "(",
                            t("Need download Google Account Verification"),
                            ")"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: "w-[334px] h-auto px-[20px] py-[24px] border-[#4A77FE] border-[1px] rounded-[10px] mt-[24px] mx-auto bg-[#F7FAFF99] hover:bg-[#2A99FF26] flex items-center",
                onClick: ()=>goWithOrderId("/android/nodevice-setup"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/image/bad.svg",
                        width: 48,
                        height: 48,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "text-[16px] leading-[24px] text-[#282938] ml-2 text-start",
                        children: [
                            t("I cant download the app"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "(",
                            t("still need the device for two-step verification"),
                            ")"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full mx-auto fixed bottom-0 bg-white border-t-[1px] border-[#E5E7EB]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-center w-full p-5 Mlg:px-0 bg-white mx-auto",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full lg:w-[620px] flex justify-between smj:px-4",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            onClick: ()=>setCurrentItem("First"),
                            className: "border-[1px] border-[#454CFF] bg-white rounded-[24px] h-[35px] flex items-center pl-[10px] pr-[19px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    className: "mr-[7px]",
                                    src: "/images/bind/bind-arrow-blue.svg",
                                    width: 18,
                                    height: 18,
                                    alt: "back"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-[15px] text-[#454CFF] font-[600]",
                                    children: t("BACK")
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Start);


/***/ }),

/***/ 20030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61906);
/* harmony import */ var _Tutorial__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23668);
/* harmony import */ var _PhoneCarousel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71166);







const StepLayout = (param)=>{
    let { step , title  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("commonAndroid");
    const [currentSlide, setcurrentSlide] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0);
    const [carousel, setCarousel] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(step[0].img);
    const [fullScreen, setFullScreen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const Handler = (index)=>{
        setCarousel(step[index].img);
        setcurrentSlide(index);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "text-[24px] text-[#282938] font-[600] mx-auto text-center",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-[50px] Dsm:mt-[36px] w-[600px] Dsm:w-full flex justify-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[360px] Dsm:w-full pt-[128px] pb-[52px] Dsm:py-0 flex flex-col justify-between flex-1",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "pl-[9px] pr-[23px] Dsm:px-0",
                            children: step.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "".concat(i != 0 ? "mt-[9px] Dsm:mt-[8px]" : "", " flex cursor-pointer"),
                                    onClick: ()=>Handler(i),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "".concat(currentSlide == i ? "text-[#FFF] bg-[#2A99FF]" : "", " text-[14px] min-w-[20px] h-[20px] rounded-[50%] flex justify-center items-center mt-[1.5px]"),
                                            children: [
                                                i + 1,
                                                "."
                                            ]
                                        }),
                                        " ",
                                        item.title
                                    ]
                                }, i))
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PhoneCarousel__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        className: "Dsm:hidden",
                        step: step,
                        currentSlide: currentSlide,
                        setcurrentSlide: setcurrentSlide,
                        carousel: carousel,
                        setCarousel: setCarousel
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "hidden Dsm:flex flex-col items-center my-[46px]",
                onClick: ()=>setFullScreen(true),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        src: "/images/android/setup/view.svg",
                        width: 39,
                        height: 34,
                        alt: "view"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mt-[14px] text-[14px] text-[#2405F2] font-[600]",
                        children: t("Watch a tutorial")
                    })
                ]
            }),
            fullScreen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Tutorial__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                step: step,
                onClose: ()=>setFullScreen(false)
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StepLayout);


/***/ }),

/***/ 52061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _StepLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20030);




const TroubleShooting = ()=>{
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("commonAndroid");
    const step = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>[
            {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        t("Check the time shown under the Backup by Google One if its inconsistent with the last backup time click Back up now to back up again"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/login/backup18.png"
                    }
                ]
            },
            {
                title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        t("Check out the storage of the account if there is no enough cloud storage you need to upgrade the storage plan or try to delete some data"),
                        "."
                    ]
                }),
                img: [
                    {
                        src: "/images/login/backup18.png"
                    }
                ]
            }
        ], [
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StepLayout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        title: t("Trouble shooting"),
        step: step
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TroubleShooting);


/***/ }),

/***/ 23668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61906);
/* harmony import */ var _PhoneCarousel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71166);






const Tutorial = (param)=>{
    let { step , onClose , imgHorizontal  } = param;
    var ref;
    const imgToggle = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    const [currentSlide, setcurrentSlide] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0);
    const [carousel, setCarousel] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)((step === null || step === void 0 ? void 0 : (ref = step[0]) === null || ref === void 0 ? void 0 : ref.img) || "");
    const [autoplay, setAutoplay] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true);
    const Handler = (index)=>{
        setCarousel(step[index].img);
        setcurrentSlide(index);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "fixed z-[99999] w-full h-[100vh] pb-[20px] bg-white top-0 overflow-auto flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full min-h-[50px] px-[15px] flex items-center justify-end",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    src: "/images/android/setup/close.svg",
                    width: 16,
                    height: 16,
                    alt: "close",
                    className: "cursor-pointer",
                    onClick: onClose
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PhoneCarousel__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                imgHorizontal: imgHorizontal,
                step: step,
                currentSlide: currentSlide,
                setcurrentSlide: setcurrentSlide,
                carousel: carousel,
                setCarousel: setCarousel
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full px-[20px] mt-[30px] smj:pb-[90px]",
                children: step.map((item, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat(i != 0 ? "mt-[9px] Dsm:mt-[8px]" : "", " flex cursor-pointer"),
                        onClick: ()=>Handler(i),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "".concat(currentSlide == i ? "text-[#FFF] bg-[#2A99FF]" : "", " text-[14px] min-w-[20px] h-[20px] rounded-[50%] flex justify-center items-center mt-[1.5px]"),
                                children: [
                                    i + 1,
                                    "."
                                ]
                            }),
                            " ",
                            item.title
                        ]
                    }, i))
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Tutorial);


/***/ }),

/***/ 84518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61906);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1954);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96456);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95629);
/* harmony import */ var _Message__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29143);
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53399);








const { TextArea  } = antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z;
const WhatsApp = ()=>{
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("androidLogin");
    const [phone, setPhone] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const [digitKey, setDigitKey] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const handleSubmit = async ()=>{
        const textWithoutSpaces = digitKey.replace(/\s/g, "") //格式化识别结果，去除空格
        ;
        if (phone == "") {
            (0,_Message__WEBPACK_IMPORTED_MODULE_5__/* .messageInfo */ .B)(t("Please enter the whatsapp number"));
            return;
        }
        if ((textWithoutSpaces === null || textWithoutSpaces === void 0 ? void 0 : textWithoutSpaces.length) !== 64) {
            (0,_Message__WEBPACK_IMPORTED_MODULE_5__/* .messageInfo */ .B)(t("Please enter the correct key"));
            return;
        }
        let username = JSON.parse(localStorage.getItem("DeviceUser")) != null ? JSON.parse(localStorage.getItem("DeviceUser")).username : "";
        let result = await (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_4__/* .androidWaKey */ .gI)({
            googleAccount: username,
            waAccount: phone,
            encryptionKey: textWithoutSpaces
        });
        if (result.data.ec === 0) {
            (0,_Message__WEBPACK_IMPORTED_MODULE_5__/* .messageInfo */ .B)(result.data.em);
            let download = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_6__.gcloudDownload)({
                mode: 5,
                username: username
            });
            (0,_Message__WEBPACK_IMPORTED_MODULE_5__/* .messageInfo */ .B)(download.data.ed);
            localStorage.setItem("encryption-key", true);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "max-w-[600px] mx-auto pb-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "text-[24px] text-[#282938] font-[600] mx-auto text-center",
                children: t("Back up WhatsApp")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "mt-[50px] flex",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    t("Step1"),
                                    ":"
                                ]
                            }),
                            "\xa0",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                                        icon: "ph:dots-three-outline-vertical-fill",
                                        fontSize: "1.5rem",
                                        style: {
                                            display: "initial"
                                        }
                                    }),
                                    "> ",
                                    t("Settings"),
                                    " > ",
                                    t("Chats"),
                                    " > ",
                                    t("Chat backup"),
                                    " > ",
                                    t("End-to-end encrypted backup"),
                                    "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "flex mt-[4px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "font-[500]",
                                children: [
                                    t("Step2"),
                                    ":"
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    t("Tap"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "font-[600]",
                                        children: [
                                            " ",
                                            t("TURN ON"),
                                            "."
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "flex mt-[4px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "font-[500]",
                                children: [
                                    t("Step3"),
                                    ":"
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    t("Tap"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "font-[600]",
                                        children: [
                                            " ",
                                            t("Use a 64-digit encryption key instead"),
                                            "."
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "flex mt-[4px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "font-[500]",
                                children: [
                                    t("Step4"),
                                    ":"
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    t("Tap"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "font-[600]",
                                        children: [
                                            " ",
                                            t("Generate your 64digit key"),
                                            "."
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "flex mt-[4px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "font-[500]",
                                children: [
                                    t("Step5"),
                                    ":"
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    t("Press and hold 64-digit key click"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "font-[600]",
                                        children: [
                                            " ",
                                            t("Copy"),
                                            "."
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "my-[14px]",
                        children: [
                            t("Then you can send the copy to your own phone or just take a picture and upload this one using the button below"),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "font-[500]",
                                children: [
                                    t("Step6"),
                                    ":"
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    t("Tap"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "font-[600]",
                                        children: [
                                            " ",
                                            t("I Saved My 64digit key"),
                                            "."
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "flex mt-[4px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "font-[500]",
                                children: [
                                    t("Step7"),
                                    ":"
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    t("Tap"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: "font-[600]",
                                        children: [
                                            " ",
                                            t("Create"),
                                            " "
                                        ]
                                    }),
                                    t("to complete"),
                                    "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "flex mt-[4px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "font-[500]",
                                children: [
                                    t("Step8"),
                                    ":"
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    t("Paste the 64digit key below and click submit"),
                                    "."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                className: "mt-[30px] rounded-[10px] w-full h-[40px] bg-[#F7F8FA] outline-none text-[16px] px-[11px]",
                placeholder: t("WhatsApp number"),
                value: phone,
                onChange: (e)=>{
                    setPhone(e.target.value.trim());
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TextArea, {
                className: "font-[600] mt-[16px] rounded-[10px] py-[10px] w-full bg-[#F7F8FA] border-0 h-[200px] text-[16px]",
                rows: 4,
                placeholder: t("64-digit key"),
                value: digitKey,
                onChange: (e)=>{
                    setDigitKey(e.target.value.trim());
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "mt-[16px] w-full h-[48px] bg-[#FFCF55] rounded-[41px] text-[16px] text-[#1B1C2B]",
                onClick: ()=>handleSubmit(),
                children: t("Submit")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WhatsApp);


/***/ }),

/***/ 7595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ MessageInfo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2453);


const MessageInfo = (param)=>{
    const key = Date.now();
    const isObject = param && typeof param === "object" && !Array.isArray(param);
    const type = (isObject ? param.type : null) || "remind";
    const duration = (isObject ? param.duration : null) || 3;
    const src = type === "success" ? "/image/success.svg" : type === "error" ? "/image/error.svg" : type === "warn" ? "/image/warn.svg" : "/image/remind.svg";
    var _content;
    const text = isObject ? (_content = param.content) !== null && _content !== void 0 ? _content : "" : param;
    const content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "max-w-[340px] w-full flex items-center gap-x-[12px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: src,
                alt: "",
                width: 24,
                height: 24
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-[14px] leading-[22px] text-[#484B60]",
                children: text
            })
        ]
    });
    antd__WEBPACK_IMPORTED_MODULE_1__/* ["default"].open */ .ZP.open({
        content,
        key,
        duration
    });
};



/***/ }),

/***/ 35951:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dashboard_box":"newGcloundLogin_dashboard_box__j_yEo","title":"newGcloundLogin_title__rdILZ","tow_step":"newGcloundLogin_tow_step__j33w8","monitor":"newGcloundLogin_monitor__e_IpD","input_box":"newGcloundLogin_input_box__2ksXS","input":"newGcloundLogin_input__QKu2y","verify_box":"newGcloundLogin_verify_box__kutbD","robot_box":"newGcloundLogin_robot_box__Dweex","img_border":"newGcloundLogin_img_border__qtKSB","cell":"newGcloundLogin_cell__NpcLQ","btn":"newGcloundLogin_btn__OfA6r"};

/***/ })

}]);